// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3wT6W","productName":"Table_productName__33jJe"};